export { default as TypePill } from './TypePill';